/**
 * Page Key Constants
 * @readonly
 * @enum {string}
 */
const PAGE_KEYS = Object.freeze({
  CALENDAR_CODE: 'CALENDARCODE',
  ORDER_OCF_ASN: 'ORDEROCFASN',
  PACKING_PROGRESS: 'PACKINGPROGRESS',
  WORKING_CALENDAR: 'WORKINGCALENDAR',
  CORRESPONDENCE_CALENDAR: 'CORRESPONDENCECALENDAR',
  EVENT_MASTER: 'EVENTMASTER',
  PART_MASTER: 'PARTMASTER',
  PAIRING_REGISTRATION: 'PAIRINGREGISTRATION',
  GROUPING_REGISTRATION: 'GROUPINGREGISTRATION',
  COLLECTIVE_VANNING_: 'COLLECTIVEVANNING',
  DISCONTINUED_PART: 'DISCONTINUEDPART',
  ORDER_VOLATILITY_SEARCH: 'ORDERVOLATILITYSEARCH',
  ORDER_COMPILING: 'ORDERCOMPILING',
  ORDERPLAN_HISTORY: 'ORDERPLANHISTORY',
  BOM_CHECK_LIST: 'BOMCHECKLIST',
  PACKING_PLAN: 'PACKINGPLAN',
  PACKING_PLAN_MONTHLY: 'PACKINGPLANMONTHLY',
  PACKING_PLAN_WEEKLY: 'PACKINGPLANWEEKLY',
  PACKING_PLAN_DAILY: 'PACKINGPLANDAILY',
  REPORT_OUTPUT: 'REPORTOUTPUT',
  PACKING_INFORMATION: 'PACKINGINFORMATION',
  CASE_INFORMATION: 'CASEINFORMATION',
  CASE_INFORMATION_DETAIL_KEY: 'CASEINFORMATIONDETAIL',
  INDEX: 'INDEX',
  JOBNET_KICK: 'JOBNETKICK',
  PACKING_CONDITION: 'PACKINGCONDITIONMAINTENANCE',
  PACKING_RESULTS_MAINTENANCE: 'PACKINGRESULTSMAINTENANCE',
  TOP_PAGE: 'TOPPAGE',
});

// Export individual constants
export const CALENDARCODE_KEY = PAGE_KEYS.CALENDAR_CODE;
export const ORDEROCFASN_KEY = PAGE_KEYS.ORDER_OCF_ASN;
export const PACKINGPROGRESS_KEY = PAGE_KEYS.PACKING_PROGRESS;
export const WORKINGCALENDAR_KEY = PAGE_KEYS.WORKING_CALENDAR;
export const CORRESPONDENCECALENDAR_KEY = PAGE_KEYS.CORRESPONDENCE_CALENDAR;
export const EVENTMASTER_KEY = PAGE_KEYS.EVENT_MASTER;
export const PARTMASTER_KEY = PAGE_KEYS.PART_MASTER;
export const PAIRINGREGISTRATION_KEY = PAGE_KEYS.PAIRING_REGISTRATION;
export const GROUPINGPART_KEY = PAGE_KEYS.GROUPING_REGISTRATION;
export const COLLECTIVEVANNING_KEY = PAGE_KEYS.COLLECTIVE_VANNING_;
export const DISCONTINUEDPART_KEY = PAGE_KEYS.DISCONTINUED_PART;
export const ORDERVOLATILITYSEARCH_KEY = PAGE_KEYS.ORDER_VOLATILITY_SEARCH;
export const ORDERCOMPILING_KEY = PAGE_KEYS.ORDER_COMPILING;
export const ORDERPLANHISTORY_KEY = PAGE_KEYS.ORDERPLAN_HISTORY;
export const BOMCHECKLIST_KEY = PAGE_KEYS.BOM_CHECK_LIST;
export const PACKINGPLAN_KEY = PAGE_KEYS.PACKING_PLAN;
export const PACKINGPLANMONTHLY_KEY = PAGE_KEYS.PACKING_PLAN_MONTHLY;
export const PACKINGPLANWEEKLY_KEY = PAGE_KEYS.PACKING_PLAN_WEEKLY;
export const PACKINGPLANDAILY_KEY = PAGE_KEYS.PACKING_PLAN_DAILY;
export const PACKINGINFORMATION_KEY = PAGE_KEYS.PACKING_INFORMATION;
export const CASEINFORMATION_KEY = PAGE_KEYS.CASE_INFORMATION;
export const CASE_INFORMATION_DETAIL_KEY = PAGE_KEYS.CASE_INFORMATION_DETAIL_KEY;
export const INDEX_KEY = PAGE_KEYS.INDEX;
export const JOBNETKICK_KEY = PAGE_KEYS.JOBNET_KICK;
export const PACKINGCONDITION_KEY = PAGE_KEYS.PACKING_CONDITION;
export const PACKINGRESULTSMAINTENANCE_KEY = PAGE_KEYS.PACKING_RESULTS_MAINTENANCE;
export const REPORTOUTPUT_KEY = PAGE_KEYS.REPORT_OUTPUT;
export const TOPPAGE_KEY = PAGE_KEYS.TOP_PAGE;

//閲覧のみ可能
export const ACCESS_READ = '1';
//編集可能
export const ACCESS_WRITE = '2';
//SMC 日本
export const SMC_PRCT_CODE = '100100';
